"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notifyError = exports.notify = void 0;
const notyf_1 = require("notyf");
require("notyf/notyf.min.css");
const notyf = new notyf_1.Notyf({
    duration: 1000,
    position: {
        x: 'right',
        y: 'top',
    },
    types: [
        {
            type: 'warning',
            background: 'orange',
            icon: {
                className: 'material-icons',
                tagName: 'i',
                text: 'warning'
            }
        },
        {
            type: 'error',
            background: 'indianred',
            duration: 3000,
            dismissible: true
        }
    ]
});
function notify(type, message) {
    notyf.open({
        type: type,
        message: message,
    });
}
exports.notify = notify;
function notifyError(message) {
    notyf.open({
        type: 'error',
        message: message ? message : 'Something went wrong!',
    });
}
exports.notifyError = notifyError;
